/* eslint-disable */
import React from 'react';

import Select from 'react-dropdown-select';

const PlaylistDropDownComponent = ({ options, title, placeholder, eventChange }) => (
  <React.Fragment>
    <p>{title}</p>
    <Select
      options={options}
      values={[]}
      placeholder={placeholder}
      valueField="createdAt"
      labelField="name"
      onChange={(values) => eventChange(values)}
    />
  </React.Fragment>
);

PlaylistDropDownComponent.propTypes = {};

export default PlaylistDropDownComponent;
